// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-wrapper[data-v-bc99eb60] {
  position: relative;
  width: 350px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-left: 1px solid var(--border-info-left);
}
.info-wrapper .sections[data-v-bc99eb60] {
  overflow-x: hidden;
}
.info-wrapper .sections[data-v-bc99eb60] .list-item {
  flex-wrap: nowrap;
}
.info-wrapper .sections[data-v-bc99eb60] .list-item .item-title {
  white-space: nowrap;
}
.info-wrapper .sections[data-v-bc99eb60] .switch-item .switch > * {
  flex: 1;
}
.info-wrapper .transition-wrapper[data-v-bc99eb60] {
  width: 350px;
  overflow: hidden;
  position: absolute;
  height: 100%;
  background-color: var(--transition-wrapper-bgcolor);
  display: flex;
  flex-direction: column;
}
.info-wrapper .transition-wrapper > *[data-v-bc99eb60] {
  width: 100%;
}
.info-wrapper .info-switch-new-enter-to[data-v-bc99eb60] {
  animation: slide-new-in-bc99eb60 0.25s forwards;
}
.info-wrapper .info-switch-new-enter-active[data-v-bc99eb60] {
  z-index: 10;
}
.info-wrapper .info-switch-new-enter-active[data-v-bc99eb60]:not(.info-switch-new-enter-to) {
  display: none !important;
}
.info-wrapper .info-switch-new-leave-to[data-v-bc99eb60] {
  animation: slide-new-out-bc99eb60 0.25s forwards;
}
.info-wrapper .info-switch-back-leave-to[data-v-bc99eb60] {
  animation: slide-back-out-bc99eb60 0.25s forwards;
}
.info-wrapper .info-switch-back-enter-active[data-v-bc99eb60]:not(.info-switch-back-enter-to) {
  display: none !important;
}
.info-wrapper .info-switch-back-leave-active[data-v-bc99eb60] {
  z-index: 10;
}
.info-wrapper .info-switch-back-enter-to[data-v-bc99eb60] {
  animation: slide-back-in-bc99eb60 0.25s forwards;
}
@keyframes slide-new-in-bc99eb60 {
0% {
    transform: translateX(100%);
}
100% {
    transform: translateX(0%);
}
}
@keyframes slide-new-out-bc99eb60 {
0% {
    transform: translateX(0%);
}
30% {
    transform: translateX(-30%);
}
100% {
    transform: translateX(-40%);
}
}
@keyframes slide-back-in-bc99eb60 {
0% {
    transform: translateX(-40%);
}
100% {
    transform: translateX(0%);
}
}
@keyframes slide-back-out-bc99eb60 {
0% {
    transform: translateX(0%);
}
100% {
    transform: translateX(100%);
}
}
@keyframes alt-icon-fade-in-bc99eb60 {
from {
    background-color: transparent;
    color: transparent;
}
to {
    background-color: var(--main-body-color);
    color: var(--bg-color);
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/InfoWrapper.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8CAA8C;AAChD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mDAAmD;EACnD,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,+CAA+C;AACjD;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;EACE,gDAAgD;AAClD;AACA;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;AACA;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;AACA;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;AACA;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;AACA;AACA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,wCAAwC;IACxC,sBAAsB;AAC1B;AACA","sourcesContent":[".info-wrapper[data-v-bc99eb60] {\n  position: relative;\n  width: 350px;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border-left: 1px solid var(--border-info-left);\n}\n.info-wrapper .sections[data-v-bc99eb60] {\n  overflow-x: hidden;\n}\n.info-wrapper .sections[data-v-bc99eb60] .list-item {\n  flex-wrap: nowrap;\n}\n.info-wrapper .sections[data-v-bc99eb60] .list-item .item-title {\n  white-space: nowrap;\n}\n.info-wrapper .sections[data-v-bc99eb60] .switch-item .switch > * {\n  flex: 1;\n}\n.info-wrapper .transition-wrapper[data-v-bc99eb60] {\n  width: 350px;\n  overflow: hidden;\n  position: absolute;\n  height: 100%;\n  background-color: var(--transition-wrapper-bgcolor);\n  display: flex;\n  flex-direction: column;\n}\n.info-wrapper .transition-wrapper > *[data-v-bc99eb60] {\n  width: 100%;\n}\n.info-wrapper .info-switch-new-enter-to[data-v-bc99eb60] {\n  animation: slide-new-in-bc99eb60 0.25s forwards;\n}\n.info-wrapper .info-switch-new-enter-active[data-v-bc99eb60] {\n  z-index: 10;\n}\n.info-wrapper .info-switch-new-enter-active[data-v-bc99eb60]:not(.info-switch-new-enter-to) {\n  display: none !important;\n}\n.info-wrapper .info-switch-new-leave-to[data-v-bc99eb60] {\n  animation: slide-new-out-bc99eb60 0.25s forwards;\n}\n.info-wrapper .info-switch-back-leave-to[data-v-bc99eb60] {\n  animation: slide-back-out-bc99eb60 0.25s forwards;\n}\n.info-wrapper .info-switch-back-enter-active[data-v-bc99eb60]:not(.info-switch-back-enter-to) {\n  display: none !important;\n}\n.info-wrapper .info-switch-back-leave-active[data-v-bc99eb60] {\n  z-index: 10;\n}\n.info-wrapper .info-switch-back-enter-to[data-v-bc99eb60] {\n  animation: slide-back-in-bc99eb60 0.25s forwards;\n}\n@keyframes slide-new-in-bc99eb60 {\n0% {\n    transform: translateX(100%);\n}\n100% {\n    transform: translateX(0%);\n}\n}\n@keyframes slide-new-out-bc99eb60 {\n0% {\n    transform: translateX(0%);\n}\n30% {\n    transform: translateX(-30%);\n}\n100% {\n    transform: translateX(-40%);\n}\n}\n@keyframes slide-back-in-bc99eb60 {\n0% {\n    transform: translateX(-40%);\n}\n100% {\n    transform: translateX(0%);\n}\n}\n@keyframes slide-back-out-bc99eb60 {\n0% {\n    transform: translateX(0%);\n}\n100% {\n    transform: translateX(100%);\n}\n}\n@keyframes alt-icon-fade-in-bc99eb60 {\nfrom {\n    background-color: transparent;\n    color: transparent;\n}\nto {\n    background-color: var(--main-body-color);\n    color: var(--bg-color);\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
